import { getFailureActionType, getSuccessActionType } from '@microsoft/portal-app/lib/redux/createAjaxEpic';
import { createAction } from '@reduxjs/toolkit';
import { AccountActions } from '../models';

export const actionSubmitLeaveOrg = createAction(AccountActions.submitLeaveOrganization);

export const actionLeaveOrgSuccess = createAction(getSuccessActionType(AccountActions.submitLeaveOrganization));

export const actionLeaveOrgError = createAction(
  getFailureActionType(AccountActions.submitLeaveOrganization),
  error => ({ payload: undefined, error })
);

export const actionCancelLeaveOrg = createAction(AccountActions.cancelLeaveOrganization);
